import { InformationCircleIcon } from "@heroicons/react/24/solid";
import ReactTooltip from "react-tooltip";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export function RoundHeader() {
  return /*#__PURE__*/_jsxs("div", {
    className: "px-4 flex items-center justify-between font-modern-era-regular font-medium text-lg/[26px]",
    children: [/*#__PURE__*/_jsx("div", {
      className: "flex-1",
      children: "Round"
    }), /*#__PURE__*/_jsxs("div", {
      className: "flex flex-row flex-1 gap-1 items-center justify-center",
      children: [/*#__PURE__*/_jsx("div", {
        className: "text-center",
        children: "Total Donation"
      }), /*#__PURE__*/_jsxs("div", {
        className: "flex items-center",
        children: [/*#__PURE__*/_jsx(InformationCircleIcon, {
          "data-tip": true,
          "data-background-color": "#0E0333",
          "data-for": "donation-tooltip",
          className: "inline size-5",
          "data-testid": "donation-tooltip",
          fill: "black"
        }), /*#__PURE__*/_jsx(ReactTooltip, {
          id: "donation-tooltip",
          place: "bottom",
          type: "dark",
          effect: "solid",
          children: /*#__PURE__*/_jsxs("p", {
            className: "text-xs",
            children: ["The displayed amount in USD reflects ", /*#__PURE__*/_jsx("br", {}), "the value at the time of your donation."]
          })
        })]
      })]
    }), /*#__PURE__*/_jsx("div", {
      className: "flex-1"
    })]
  });
}